// Focus Visible Polyfill
import 'focus-visible'

// Internal Modules
import { launchConfetti } from './modules/confetti'
;;(function () {
	function setupClickEventListeners() {
		const radios = document.querySelectorAll('input[type="radio"]')

		radios.forEach((radio) => {
			radio.addEventListener('click', function () {
				smoothScrollAndModifyClasses(radio)
			})
		})
	}

	function smoothScrollAndModifyClasses(clickedRadio) {
		const phoneContainer = document.querySelector('.phone-container')
		if (phoneContainer) {
			phoneContainer.scrollIntoView({ behavior: 'smooth', block: 'start' })

			const observer = new IntersectionObserver(
				(entries, obs) => {
					entries.forEach((entry) => {
						if (entry.isIntersecting) {
							updateImageDisplay(clickedRadio)
							obs.disconnect() // Stop observing once the task is completed
						}
					})
				},
				{ threshold: 0.1 }
			) // Lower threshold to ensure it triggers more easily

			observer.observe(phoneContainer)
		}
	}

	function updateImageDisplay(clickedRadio) {
		const appleImage = document.querySelector('.apple')
		const androidImage = document.querySelector('.android')

		if (clickedRadio.value === 'Apple') {
			androidImage.classList.add('shrink-and-darken')
			appleImage.classList.remove('shrink-and-darken')
			appleImage.classList.add('grow-and-brighten')
		} else if (clickedRadio.value === 'Android') {
			appleImage.classList.add('shrink-and-darken')
			androidImage.classList.remove('shrink-and-darken')
			androidImage.classList.add('grow-and-brighten')
		}
	}

	const promenade = document.querySelector('#promenade')
	if (promenade) {
		const observer = new MutationObserver((mutations) => {
			mutations.forEach((mutation) => {
				if (mutation.addedNodes.length) {
					setupClickEventListeners()
				}
			})
		})
		observer.observe(promenade, { childList: true, subtree: true })
	} else {
		console.log('#promenade not found at script initialization.')
	}
})()
;(function () {
	// Mutation observer to detect when the specific class is added to the DOM
	const promenade = document.querySelector('#promenade')
	if (promenade) {
		const observer = new MutationObserver((mutations) => {
			mutations.forEach((mutation) => {
				if (mutation.addedNodes.length) {
					mutation.addedNodes.forEach((node) => {
						if (node.nodeType === Node.ELEMENT_NODE) {
							const targetElement = node.querySelector(
								'.bw-offer-step-69e0b247-5eb0-4256-a9b6-d9c5055f8cf7'
							)
							if (targetElement) {
								console.log(
									'.bw-offer-step-69e0b247-5eb0-4256-a9b6-d9c5055f8cf7 added to the DOM.'
								)
								window.scrollTo({ top: 0, behavior: 'smooth' }) // Scroll to top
								launchConfetti() // Launch confetti when the specific element is added
							}
						}
					})
				}
			})
		})

		observer.observe(promenade, { childList: true, subtree: true })
		console.log('Observer attached to #promenade.')
	} else {
		console.log('#promenade not found at script initialization.')
	}
})()
